import { _daysAgoStripeEventSearch, _debugMode, _stripeCustomerRefVar, _stripeLink, _userUniqueId } from './constants';


export function goToPayment(userUniqueId: string | null) {
  if (userUniqueId == null) { return; }
  const url = _stripeLink + '?' + _stripeCustomerRefVar + '=' + userUniqueId;
  window.location.href = url;
}
 


